module.exports = __webpack_public_path__ + "media/images/about_drawing-803b32365f116a283d2ed40a2fcb9e7f.png";